import { generateUUID } from '../utils';

/**
 * TODO 从反作弊处获取设备 uuid
 * 目前使用内存变量定义一次访问
 */
function getUUID() {
  if (!window._uuid) {
    window._uuid = generateUUID();
  }

  return window._uuid;
}

export default getUUID;
